<template>
  <Layout>
    <template #header>
      舒适停车
      <!-- <div style="margin-left: auto; margin-right: 30px">
        请开始中度或轻度制动,并保持制动踏板,直至车辆停止
      </div> -->
    </template>
    <template #default>
      <div class="row q-col-gutter-x-md full-height">
        <div class="col-3 col-xs-12 col-sm-3 full-height">
          <q-card bordered class="full-height column">
            <q-card-section class="row">
              <ToggleSwitch
                v-model="comfortParkingEnabled"
                color="#4caf50"
                true-value="功能开启"
                false-value="功能关闭"
                :disabled="playStatus === 'play'"

              >
              </ToggleSwitch>
            </q-card-section>
            <!-- <q-toggle
              v-model="comfortParkingEnabled"
              checked-icon="check"
              color="green-7"
              unchecked-icon="clear"
              false-value="功能关闭"
              true-value="功能开启"
              size="xl"
              :disable="playStatus === 'play'"
            /> -->

            <q-card-section
              class="row justify-center items-center"
              style="flex: 1"
            >
              <div
                class="text-h5"
                style="font-weight: bold; position: absolute; top: 15px"
              >
                制动强度
              </div>
              <div class="charts-container">
                <div style="height: 500px; margin-left: 10px">
                  <Charts :options="option" ref="charts" />
                  <!-- <AngleWheel
                    :value="value"
                    :max="20000"
                    :min="0"
                    class="chart"
                    ref="charts"
                    style="height: 500px; width: 200px"
                  /> -->
                </div>
                <div
                  class="charts-controls"
                  style="margin-top: 10px; text-align: center"
                ></div>
                <div>
                  <div
                    style="
                      position: absolute;
                      top: 105px;
                      left: 0px;
                      font-size: 16px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <div :style="highValueStyle" class="breathe-div"></div>
                    <span>重</span>
                  </div>
                  <div
                    style="
                      position: absolute;
                      top: 270px;
                      left: 0px;
                      font-size: 16px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <div :style="suitableValueStyle" class="breathe-div"></div>
                    <span>适合</span>
                  </div>
                  <div
                    style="
                      position: absolute;
                      top: 445px;
                      left: 0px;
                      font-size: 16px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <div :style="lowValueStyle" class="breathe-div"></div>
                    <span>轻</span>
                  </div>
                  <div
                    style="
                      position: absolute;
                      top: 22px;
                      left: 90px;
                      font-size: 20px;
                      width: 70px;
                      height: 30px;
                      text-align: center;
                    "
                  >
                    {{ value }}N
                  </div>
                </div>
              </div>
            </q-card-section>
            <q-img
              :src="制动踏板"
              style="
                width: 50px;
                height: 40px;
                position: absolute;
                bottom: 0%;
                left: 60%;
                transform: translate(-50%, -50%) scaleX(-1);
              "
            />
          </q-card>
        </div>
        <div class="col-9 column q-col-gutter-y-md">
          <div style="flex: 1">
            <q-card bordered class="row full-height">
              <q-card-section class="overflow-hidden q-pa-none" style="flex: 1">
                <div class="full-height row overflow-hidden">
                  <div class="col-6 overflow-hidden" style="flex: 1">
                    <DomainControlCharts
                      :title="title1"
                      :max="15000"
                      :min="0"
                      :start="0"
                      :end="15000"
                      :xAxisLength="6"
                      :series="optionsA"
                      :grid="grid"
                      :legendTop="50"
                      :showXAxisLabel="true"
                      :data-zomm-mirror-drag="false"
                    />
                  </div>
                  <div class="col-6 overflow-hidden" style="flex: 1">
                    <DomainControlCharts
                      :title="title2"
                      :max="15000"
                      :min="0"
                      :start="0"
                      :end="15000"
                      :xAxisLength="6"
                      :series="optionsB"
                      :legendTop="50"
                      :grid="grid"
                      :showXAxisLabel="true"
                      :data-zomm-mirror-drag="false"
                    />
                  </div>
                </div>
              </q-card-section>
            </q-card>
          </div>
          <div style="flex: 1">
            <q-card bordered class="column full-height">
              <q-card-section class="overflow-hidden q-pa-none" style="flex: 1">
                <div class="full-height column overflow-hidden">
                  <div class="col-6 overflow-hidden" style="flex: 1">
                    <DomainControlCharts
                      :title="title3"
                      :max="0.4"
                      :min="-0.6"
                      :start="0.4"
                      :end="-0.6"
                      :grid="grid"
                      :xAxisLength="6"
                      :legendTop="50"
                      :series="optionsC"
                      :showXAxisLabel="true"
                      :data-zomm-mirror-drag="false"
                    />
                  </div>
                  <!-- <div class="col-6 overflow-hidden" style="flex: 1">
                    <DomainControlCharts
                      :title="title4"
                      :max="2"
                      :min="-2"
                      :start="1"
                      :end="-1"
                      :xAxisLength="8"
                      :series="optionsD"
                      :grid="grid"
                      :showXAxisLabel="true"
                      :data-zomm-mirror-drag="false"
                    />
                  </div> -->
                </div>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref, watch } from "vue";
import Layout from "./components/Layout.vue";
import {
  decreasingSequence,
  getChartsDefaultOptions,
  getDefaultSeriesData,
  getGrid,
  getTitle2,
  getTitle,
  optionseries1,
  optionseries2,
  optionseries3,
  PlayStatus,
  getTitle3,
  getChartsDefaultOptions2,
} from "./helper/cst";
import Charts from "@/components/Charts";
import {
  generateMockCSTNofifyData,
  NOTIFY,
} from "@/services/domainControl/cst";
// import AngleWheel from "@/components/AngleWheel.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import { useDomainControlStore } from "@/stores/domainControl";
import DomainControlCharts from "@/components/DomainControlCharts";
import 制动踏板 from "@/assets/img/制动踏板.png";
import { useQuasar } from "quasar";
import ToggleSwitch from "@/components/ToggleSwitch";
const $q = useQuasar();
const titleOption = getTitle($q);
const grid = getGrid();
const titleOption2 = getTitle2($q);
const titleOption3 = getTitle3($q);
const playStatus = ref<PlayStatus>("pause");
const comfortParkingEnabled = ref("功能关闭");
const value = ref<number>(0);
const option = ref(getChartsDefaultOptions(value.value));
// const option = ref(getChartsDefaultOptions2(value.value));
const charts = ref();
const optionsA = ref(optionseries1());
const optionsB = ref(optionseries2());
const optionsC = ref(optionseries3());
const seriesData = ref(getDefaultSeriesData());
const domainControlStore = useDomainControlStore();
const resultArray = ref<number[]>([]);
const DrvrReqTrgtFxBrk_Bch1List = ref<number[]>();
const notifyData = reactive({} as Partial<DomianControl.CSTNotifyData>);
let isPlayStatusChanged = ref(false);
const isInited = ref(false);
const title1 = { text: "功能关闭", ...titleOption2 };
const title2 = { text: "功能开启", ...titleOption };
const title3 = { text: "纵向减速度", ...titleOption3 };
// const title4 = { text: "车辆俯仰角", ...titleOption };
const handleNotify = async (data: DomianControl.CSTNotifyData) => {
  // 计算当前的刹车力值
  value.value = Math.abs(data.UIRx_DrvrReqTrgtFxBrk_Bch1);
  // 计算总的刹车力值
  const totalBrakeForceValue =
    (data.UIRx_WhlBrkTqAct_FL_BCh1 +
      data.UIRx_WhlBrkTqAct_FR_BCh1 +
      data.UIRx_WhlBrkTqAct_RL_BCh1 +
      data.UIRx_WhlBrkTqAct_RR_BCh1) /
    0.374;
  await parseData(data, totalBrakeForceValue);
  if (playStatus.value === "play") parseSeriesData(data);
};
const parseData = async (
  value: DomianControl.CSTNotifyData,
  totalBrakeForceValue: any
) => {
  if (
    (value.UIRx_VehSpd as any) <= 15 &&
    (value.UIRx_VehSpd as any) >= 7 &&
    totalBrakeForceValue > 0 &&
    !isPlayStatusChanged.value &&
    value.UIRx_VehSdsl !== 1
  ) {
    isPlayStatusChanged.value = true; // 设置标志变量为 true
    await handlePlayStatusChange("play");
  }

  Object.keys(value).forEach((key) => {
    notifyData[key] = value[key];
  });
};

const handleSliderChange = (type: string, value: number) => {
  domainControlStore.writeOutputValue({
    [type]: value,
  });
};

const parseOutputValue = (value: DomianControl.OutputValue) => {
  const { UITx_CST_Ena } = value;
  comfortParkingEnabled.value = UITx_CST_Ena === 1 ? "功能开启" : "功能关闭";
  isInited.value = true;
};

watch(comfortParkingEnabled, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    const value = newValue === "功能开启" ? 1 : 0;
    handleSliderChange("UITx_CST_Ena", value);
  }
});

watch([seriesData], (newValue) => {
  const {
    // 纵向减速度
    UIRx_ACULongdAcc,
    // 车辆俯仰角，VDM 通过四个悬架高度信号计算
    // UIRx_PitchAng,
  } = newValue[0];
  if (!isInited.value) return;
  if (comfortParkingEnabled.value === "功能开启") {
    (optionsB.value as any)[0].data = DrvrReqTrgtFxBrk_Bch1List.value;
    (optionsB.value as any)[1].data = resultArray.value;
    (optionsC.value as any)[0].data = UIRx_ACULongdAcc?.map((num) =>
      parseFloat(num.toFixed(2))
    );
    // (optionsD.value as any)[1].data = UIRx_PitchAng?.map((num) =>
    //   parseFloat(num.toFixed(2))
    // );
  } else if (comfortParkingEnabled.value === "功能关闭") {
    (optionsA.value as any)[0].data = DrvrReqTrgtFxBrk_Bch1List.value;
    (optionsA.value as any)[1].data = resultArray.value;
    (optionsC.value as any)[1].data = UIRx_ACULongdAcc?.map((num) =>
      parseFloat(num.toFixed(2))
    );
    // (optionsD.value as any)[0].data = UIRx_PitchAng?.map((num) =>
    //   parseFloat(num.toFixed(2))
    // );
  }
});

const parseSeriesData = (data: DomianControl.CSTNotifyData) => {
  if (seriesData.value.UIRx_ACULongdAcc) {
    if (seriesData.value.UIRx_ACULongdAcc.length >= decreasingSequence.length) {
      handlePlayStatusChange("pause");
      isPlayStatusChanged.value = false; // 重置标志变量
      return;
    }
  }
  const res = [
    // 左前轮实际制动力
    "UIRx_WhlBrkTqAct_FL_BCh1",
    // 右前轮实际制动力
    "UIRx_WhlBrkTqAct_FR_BCh1",
    // 左后轮实际制动力
    "UIRx_WhlBrkTqAct_RL_BCh1",
    // 右后轮实际制动力
    "UIRx_WhlBrkTqAct_RR_BCh1",
    // 驾驶员制动意图
    "UIRx_DrvrReqTrgtFxBrk_Bch1",
    // 车辆静止信号
    "UIRx_VehSdsl",
    // 纵向减速度
    "UIRx_ACULongdAcc",
    // 车辆俯仰角，VDM 通过四个悬架高度信号计算
    "UIRx_PitchAng",
    // 参考车速
    "UIRx_VehSpd",
  ].reduce((per, key) => {
    const value = data[key];
    const curList = seriesData.value[key] || [];
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push(value);
    per[key] = curList.concat();
    return per;
  }, {} as DomianControl.CSTSeriesData);
  seriesData.value = res;

  // 计算总制动力
  const totalBrakeForceValue =
    ((res.UIRx_WhlBrkTqAct_FL_BCh1?.at(-1) ?? 0) +
      (res.UIRx_WhlBrkTqAct_FR_BCh1?.at(-1) ?? 0) +
      (res.UIRx_WhlBrkTqAct_RL_BCh1?.at(-1) ?? 0) +
      (res.UIRx_WhlBrkTqAct_RR_BCh1?.at(-1) ?? 0)) /
    0.374;
  console.log("[BOWEN_LOG] 🚀 ~~ totalBrakeForceValue:", totalBrakeForceValue);
  DrvrReqTrgtFxBrk_Bch1List.value = res.UIRx_DrvrReqTrgtFxBrk_Bch1?.map(
    (item) => {
      return Math.abs(Math.round(item));
    }
  );
  // 将总制动力值添加到 resultArray 中
  if (resultArray.value.length >= decreasingSequence.length)
    resultArray.value.shift();
  resultArray.value.push(Math.round(totalBrakeForceValue));
};

watch(value, (newValue) => {
  if (newValue !== null) {
    // option.value = getChartsDefaultOptions2(newValue);
    option.value = getChartsDefaultOptions(newValue);
  }
});
const handlePlayStatusChange = async (value: PlayStatus) => {
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    DrvrReqTrgtFxBrk_Bch1List.value = [];
    resultArray.value = [];
  }
  playStatus.value = value;
};
useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

// 计算属性，用于生成动态样式
const highValueStyle = computed(() => ({
  backgroundColor: value.value > 10000 ? "#b71c1c" : "#9ba6a5",
  boxShadow: value.value > 10000 ? "0 0 15px #b71c1c" : "0 0 0px #c6d4d2",
}));
const suitableValueStyle = computed(() => ({
  backgroundColor:
    value.value <= 10000 && value.value >= 4000 ? "#4caf50" : "#9ba6a5",
  boxShadow:
    value.value <= 10000 && value.value >= 4000
      ? "0 0 15px #4caf50"
      : "0 0 0px #4caf50",
}));
const lowValueStyle = computed(() => ({
  backgroundColor: value.value < 4000 ? "#9ba6a5" : "#9ba6a5",
  boxShadow: value.value < 4000 ? "0 0 15px #9ba6a5" : "0 0 0px #c6d4d2",
}));
</script>

<style scoped>
.charts-container {
  position: relative;
  width: 200px;
  top: -10px;
}
.breathe-div {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
  background-color: aquamarine;
  margin-right: 10px;
}
.glowing-effect {
  position: relative;
  top: -15px;
  width: 70%;
  height: 10px; /* 根据需求调整高度 */
  margin: 0 auto;
}

.glowing-effect::before {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* 中间亮，边缘透明 */
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
</style>
